import { AnimatePresence, motion } from "framer-motion";
import { ComponentType, forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export interface ValidateProps {
  errorMessage?: string;
  label?: string;
  className?: string;
  required?: boolean;
  labelClassName?: string;
}

export const withValidate = <P extends object>(Component: ComponentType<P>) => {
  return forwardRef<P, ValidateProps & P>(
    (
      { errorMessage, className, label, required, labelClassName, ...props },
      ref
    ) => {
      return (
        <>
          {label && (
            <p className={twMerge("mb-2 text-sm font-medium", labelClassName)}>
              {label}
              {required && <strong className="text-red">*</strong>}
            </p>
          )}
          <Component
            className={twMerge(className, errorMessage && "border-red")}
            {...(props as P)}
            ref={ref}
          />
          <AnimatePresence>
            {errorMessage && (
              <motion.p
                className="mt-2 text-xs text-red"
                initial={{
                  transform: "translateY(-100%)",
                  opacity: 0,
                }}
                animate={{
                  transform: "translateY(0)",
                  opacity: 1,
                }}
                exit={{
                  transform: "translateY(-100%)",
                  opacity: 0,
                }}
              >
                {errorMessage}
              </motion.p>
            )}
          </AnimatePresence>
        </>
      );
    }
  );
};
